module.exports = __webpack_public_path__ + "static/media/Bijay_Kumar.f4ca83e4.png";